import React, { useState, useEffect } from "react";
import { PathName } from "../../../utils/routes";
import { isWhiteLabelClient } from "../../../utils/utilities";
import { ReactComponent as NotQQIcon } from "../../../assets/icons/candidate-assessment/not-qq.svg";
import AssessmentTestInfoWrapper from "../../../components/candidate-assessment-flow/AssessmentTestInfoWrapper";
import { ReactComponent as TestFuseWatermarkIcon } from "../../../assets/icons/candidate-assessment/Watermark.svg";

export default function AssessmentNotQualified() {
  const [returnWL, setReturnWL] = useState(false);
  const [processing, setProcessing] = useState(false);
  const [cachedDomain, setCachedDomain] = useState(null);
  const wlSettingsData = JSON.parse(localStorage.getItem("wl_settings_data"));

  const handleSubmitWL = async () => {
    setProcessing(true);
    const domain = wlSettingsData?.domain ? wlSettingsData?.domain : "*";
    localStorage.removeItem("tenant_data");
    localStorage.removeItem("wl_assess_id");
    localStorage.removeItem("wl_client_id");
    localStorage.removeItem("wl_access_token");
    localStorage.removeItem("wl_refresh_token");
    localStorage.removeItem("wl_settings_data");
    setCachedDomain(domain);
    setReturnWL(true);
    setProcessing(false);
  };

  useEffect(() => {
    if (returnWL && cachedDomain) {
      window.parent.postMessage(
        {
          type: "ASSESSMENT_COMPLETED",
          payload: {
            message: "Assessment Completed",
          },
        },
        window._env_?.NODE_ENV === "production" ? cachedDomain || "*" : "*"
      );
    }
  }, [returnWL, cachedDomain]);
  return (
    <div className="candidate-assessment-flow-container">
      <div
        className="candidate-assment-flow-wrapper"
        style={{ height: "80vh" }}
      >
        <AssessmentTestInfoWrapper
          title={<></>}
          primaryBtnTitle={
            isWhiteLabelClient() ? "Continue" : "Go back to assessment(s)"
          }
          btnWidth={"max-content"}
          disableSecondaryBtn={true}
          btnSize={"lg"}
          processing={
            // isWhiteLabelClient() ? returnWL || processing :
            processing
          }
          onPrimaryBtnClick={() => {
            isWhiteLabelClient()
              ? handleSubmitWL()
              : window.location.replace(PathName.ASSESSMENTS);
          }}
        >
          <div
            className="d-flex flex-column justify-content-center align-items-center"
            style={{ gap: "24px" }}
          >
            <NotQQIcon />
            <span className="headline-4 dark-100">{`Unfortunately, you are not qualified for this assessment!`}</span>
          </div>
        </AssessmentTestInfoWrapper>
      </div>
      <div
        className="watermark"
        style={{ height: "80px", paddingBottom: "24px" }}
      >
        {isWhiteLabelClient() ? (
          <></>
        ) : (
          <TestFuseWatermarkIcon style={{ height: "50px" }} />
        )}
      </div>
    </div>
  );
}
